const ITEMS = [
  "AI Receptionists",
  "Multilingual Voice",
  "CRM Leads",
  "Marketing Studio",
  "Talk to AI",
  "తెలుగు",
  "हिन्दी",
  "English (UK)",
  "English (US)",
  "Zero Missed Calls",
];

export default function Marquee() {
  return (
    <section
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-neutral-200 py-6 sm:py-8"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center">
                <span
                  className={`whitespace-nowrap text-3xl font-black tracking-tight sm:text-4xl ${
                    i % 2 === 1 ? "text-outline" : "text-[#111111]"
                  }`}
                >
                  {t}
                </span>
                <span className="mx-10 h-2 w-2 shrink-0 rounded-full bg-neutral-300" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
